import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import MainHeader from './MainHeader.jsx';
import LicenseBanner from './LicenseBanner.jsx';
import { useAuth } from '../../lib/auth.jsx';

const FULL_BLEED = new Set(['/map', '/style-editor']);

export default function AppLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-ink-500">
        <i className="fa-duotone fa-spinner-third fa-spin mr-2" />
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const fullBleed = FULL_BLEED.has(location.pathname);

  return (
    <div className="flex h-full">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        {/* License banner sits above MainHeader so it's visible across
            every page including full-bleed Map / Style editor — admins
            need to see "license is restrictive" no matter where they are
            in the SPA. Renders nothing when status is healthy. */}
        <LicenseBanner />
        {!fullBleed && <MainHeader />}
        <main className={fullBleed ? 'flex-1 overflow-hidden' : 'flex-1 overflow-auto p-6'}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
